<template lang="pug">
div
    screen-title(:title="$t('staff.title_payroll')")
      location-select(v-model="locationId")
    .columns
      .column(v-if="company.registerCommissions && liabilities")
          //h3.title.is-4(v-t="'ledger.liabilities_heading'")
          
          //.list
            .list-item.is-size-5(v-for="liab in liabilities" :key="liab.staff")
              .level.is-mobile
                .level-left
                  .level-item
                    staff-view(:id="liab.staff")
                .level-right
                  
                  .level-item
                    strong  
                      currency-view(:value="liab.due")
                  .level-item
                    button.button.is-primary(@click="payout(liab)" v-t="'ledger.actions.pay'" :disabled="!session || session.close || !$rfHasPermission('CASH_REGISTER_MANAGE')")
            .list-item.is-size-5
              strong(v-t="'ledger.total_liabilities_label'")
              span.is-pulled-right
                strong  
                  currency-view(:value="totalDue")
          //.notification.p-5(v-else)
            p.title.is-5.has-text-centered.has-text-grey(v-t="'ledger.no_liabilities'")

          
            
          .columns.is-multiline.is-mobile.mt-4(v-if="staffMembers.length")
            .column.is-6-tablet.is-6-desktop.is-4-widescreen(v-for="staff in staffMembers" :key="staff._id")
              .box.p-5.is-flex.is-flex-direction-column.is-align-items-center
                staff-pic.image-holder.is-64x64.is-round.mb-2(:staff="staff")
                staff-view.is-size-5(:id="staff._id")
                  
                
                p.has-text-weight-bold.mt-2.is-size-5
                  currency-view(:value="liabilities[staff._id]?.due || 0")
                p.is-size-7.has-text-grey(v-t="'ledger.total_liabilities_label'")
                .columns.mt-3(style="width: 100%")
                  .column
                    
                    date-view(v-if="liabilities[staff._id] && liabilities[staff._id].lastPayout" :value="liabilities[staff._id].lastPayout" format="MMM DD, YYYY")
                    span(v-else) -
                    p.is-size-7.has-text-grey(v-t="'ledger.last_payout_label'")
                  .column.has-text-right
                    currency-view(v-if="liabilities[staff._id] && liabilities[staff._id].lastPayoutAmount" :value="liabilities[staff._id].lastPayoutAmount")
                    span(v-else) -
                    p.is-size-7.has-text-grey(v-t="'ledger.payout_amount_label'")
                .mt-3(style="width: 100%")
                  button.button.is-fullwidth.has-text-weight-semibold(
                    :class="{'is-primary': liabilities[staff._id] && liabilities[staff._id].due }"
                    @click="payout(staff._id)" 
                    v-t="'ledger.actions.pay'"
                    
                    :disabled="!liabilities[staff._id] || liabilities[staff._id].due <= 0 || !$rfHasPermission('STAFF_PAYROLL_MANAGE')"
                  )
                .mt-3
                  .has-text-centered
                    a.has-text-grey.is-size-7(@click="showTransactionHistory(staff._id)" v-t="'actions.view_history'") 
          .notification.is-light.has-text-centered(v-else)
            p.is-size-5(v-t="'staff.no_staff_members'")
            //.notification.is-light.has-text-centered(v-if="!liabilities.length")
              p.is-size-5 No staff liabilities to display
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import LiabilityPayout from '../ledger/LiabilityPayout.vue'
import Transactions from '../ledger/Transactions.vue'

export default {
  name: 'Payroll',
  data() {
    return {
      locationId: null,
      loading: false
    }
  },
  computed: {
    ...mapState('ledger', ['liabilities']),
    ...mapState('company', ['company']),
    ...mapGetters('staff', ['activeServiceMembersByMainLocation']),
    staffMembers() {
      if (!this.locationId) {
        return []
      }
      return this.activeServiceMembersByMainLocation(this.locationId)
    }
  },
  watch: {
    locationId() {
      this.fetchData()
    }
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    ...mapActions('ledger', ['fetchLiabilities']),
    async fetchData() {
      if (!this.locationId) {
        return
      }
      try {
        this.loading = true
        await Promise.all([this.fetchLiabilities(this.locationId)])
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.loading = false
    },

    payout(staffId) {
      let due = this.liabilities[staffId]?.due || 0
      this.$buefy.modal.open({
        parent: this,
        component: LiabilityPayout,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        props: {staffId, due, locationId: this.locationId},
        canCancel: ['escape', 'outside']
      })
    },
    showTransactionHistory(staffId) {
      this.$buefy.modal.open({
        parent: this,
        component: Transactions,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        props: {staffId, initialTypes: ['payout']},
        canCancel: ['escape', 'outside']
      })
    }
  }
}
</script>
